export default __webpack_public_path__ + "static/media/yellow-bullet.e225d28a.svg";